/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsDynamoDbResource } from '../models/AwsDynamoDbResource';
import { AwsEc2Resource } from '../models/AwsEc2Resource';
import { AwsEksNamespaceResource } from '../models/AwsEksNamespaceResource';
import { AwsRdsResource } from '../models/AwsRdsResource';
import { AzureAksNamespaceResource } from '../models/AzureAksNamespaceResource';
import { GcpBigQueryResource } from '../models/GcpBigQueryResource';
import { GcpCloudSqlResource } from '../models/GcpCloudSqlResource';
import { GcpGkeNamespaceResource } from '../models/GcpGkeNamespaceResource';
import { GcpVmResource } from '../models/GcpVmResource';

/**
* Source resource properties. The properties present in this object change depending on the value set in `resourceType`. 
*/
export class ResourceProperties {
  'awsEc2'?: AwsEc2Resource | null;
  'awsRds'?: AwsRdsResource | null;
  'awsEksNamespace'?: AwsEksNamespaceResource | null;
  'awsDynamoDb'?: AwsDynamoDbResource | null;
  'gcpCloudSql'?: GcpCloudSqlResource | null;
  'gcpGkeNamespace'?: GcpGkeNamespaceResource | null;
  'azureAksNamespace'?: AzureAksNamespaceResource | null;
  'gcpVmResource'?: GcpVmResource | null;
  'gcpBigQuery'?: GcpBigQueryResource | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "awsEc2",
      "baseName": "awsEc2",
      "type": "AwsEc2Resource",
      "format": ""
    },
    {
      "name": "awsRds",
      "baseName": "awsRds",
      "type": "AwsRdsResource",
      "format": ""
    },
    {
      "name": "awsEksNamespace",
      "baseName": "awsEksNamespace",
      "type": "AwsEksNamespaceResource",
      "format": ""
    },
    {
      "name": "awsDynamoDb",
      "baseName": "awsDynamoDb",
      "type": "AwsDynamoDbResource",
      "format": ""
    },
    {
      "name": "gcpCloudSql",
      "baseName": "gcpCloudSql",
      "type": "GcpCloudSqlResource",
      "format": ""
    },
    {
      "name": "gcpGkeNamespace",
      "baseName": "gcpGkeNamespace",
      "type": "GcpGkeNamespaceResource",
      "format": ""
    },
    {
      "name": "azureAksNamespace",
      "baseName": "azureAksNamespace",
      "type": "AzureAksNamespaceResource",
      "format": ""
    },
    {
      "name": "gcpVmResource",
      "baseName": "gcpVmResource",
      "type": "GcpVmResource",
      "format": ""
    },
    {
      "name": "gcpBigQuery",
      "baseName": "gcpBigQuery",
      "type": "GcpBigQueryResource",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ResourceProperties.attributeTypeMap;
  }

  public constructor() {
  }
}

